import styled from 'styled-components';
export var InputContainer = styled.div.withConfig({
  displayName: "AxesTitlesstyles__InputContainer",
  componentId: "keen-widget-settings__seuxap-0"
})(["&&&{width:100%;max-width:450px;}"]);